import { useState, useEffect } from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import BookingCta from "../components/BookingCta";
import Configurator from "../components/Configurator";
import Realisations from "../components/Realisations";
import About from "../components/About";
import ZonesIntervention from "../components/ZonesIntervention";
import Reviews from "../components/Reviews";
import Diagnosis from "../components/Diagnosis";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ChatBot from "../components/ChatBot";
import FloatingCallButton from "../components/FloatingCallButton";
import TrustSection from "../components/TrustSection";
import SEOHead from "../components/SEOHead";
import { SEO_ROUTES } from "../lib/seoRoutes";

export default function Home({ seoKey = "home" }) {
  const [prefill, setPrefill] = useState({});
  const cfg = SEO_ROUTES[seoKey] || SEO_ROUTES.home;

  useEffect(() => {
    if (cfg.scrollTo && typeof window !== "undefined") {
      requestAnimationFrame(() => {
        const el = document.getElementById(cfg.scrollTo);
        if (el) el.scrollIntoView({ behavior: "auto", block: "start" });
      });
    }
  }, [cfg]);

  const handleRequestQuote = (data) => {
    setPrefill((p) => ({ ...p, ...data }));
    setTimeout(() => {
      const el = document.getElementById("contact");
      el?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 50);
  };

  return (
    <div data-testid="home-page" className="bg-[#050505] text-white min-h-screen">
      <SEOHead title={cfg.title} description={cfg.description} path={cfg.path} />
      <Nav />
      <main>
        <Hero />
        <Configurator onRequestQuote={handleRequestQuote} />
        <BookingCta />
        <Diagnosis onRequestQuote={handleRequestQuote} />
        <Realisations />
        <About />
        <ZonesIntervention />
        <TrustSection />
        <Reviews />
        <FAQ />
        <Contact prefill={prefill} />
      </main>
      <Footer />
      <ChatBot />
      <FloatingCallButton />
    </div>
  );
}
